module.exports = __webpack_public_path__ + "img/zhiwen.ac734998.png";